import type { MaybeRef } from "vue";
import { computed, toValue } from "vue";
import { useStore } from "vuex";
import type { TodoSubmission } from "@/components/MyStudentDetail/FilterableTodosSection/types";
import { hasMyStudentsToDosEnabled } from "@/composables/authorization.js";
import { useGetTodosSubmissions } from "@/providers/todosSubmissions/useGetTodosSubmissions";
import { hasTiptapText } from "@/util/tiptap";

type TodoInstructions = Record<string, unknown> | undefined;

const findTodoInstructions = (todos: TodoSubmission[], todoId: string, applicationId: string): TodoInstructions =>
  todos.find((todo) => todo.todo_id === todoId && todo.application_id === applicationId)?.instructions;

export const useTodoInstructions = (todoId: MaybeRef<string>, applicationId: MaybeRef<string | undefined>) => {
  const store = useStore();
  const participantId = computed<string | undefined>(() => store.state.currentUser?.participantId ?? undefined);

  const { data, isLoading } = useGetTodosSubmissions(participantId, {
    enabled: computed<boolean>(
      () =>
        Boolean(hasMyStudentsToDosEnabled.value) && Boolean(participantId.value) && Boolean(toValue(applicationId)),
    ),
  });

  const instructions = computed<TodoInstructions>(() => {
    const found = findTodoInstructions(data.value ?? [], toValue(todoId), toValue(applicationId) ?? "");
    return hasTiptapText(found) ? found : undefined;
  });

  return { instructions, isLoading };
};
